import './audioblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {WysiwygType} from 'types'
import {style} from 'util/style'
import {Theme} from 'views/theme'
import {Block} from './blocks'

type AudioFileType = {
	type: 'file'
	path: string
	title: string
	size: number
	mime_type: string
	url: string
	description: string
}

export type AudioBlockType = {
	audio_title?: string
	audio_description?: WysiwygType
	audio_files: Array<AudioFileType>
}

const styles = style('audioblock')

export const AudioBlock: FunctionComponent<AudioBlockType> = ({
	audio_files,
	audio_title,
	audio_description
}) => {
	if (!audio_files.length) return null

	return (
		<Block class={styles}>
			{audio_title && <div class={styles('title')}>{audio_title}</div>}
			<audio controls>
				{audio_files.map(file => (
					<source src={'/admin/' + file.path} type={file.mime_type} />
				))}
				Your browser does not support the audio element.
			</audio>
			{audio_description && (
				<div class={styles('description')}>
					<Theme.Wysiwyg>{audio_description}</Theme.Wysiwyg>
				</div>
			)}
		</Block>
	)
}
